import { useTheme } from 'antd-style'

import { PageContainer } from '@eastcoal/common/components/Layout/PageContainer'

import { AccountStatistic } from '../../components/AccountStatistic'

import { MemberInfo } from './MemberInfo'

export const HomePage = () => {
  const theme = useTheme()

  return (
    <PageContainer breadcrumb={false}>
      <MemberInfo />
      <AccountStatistic
        style={{
          marginBlockStart: theme.marginMD
        }}
      />
    </PageContainer>
  )
}
